/**
 * Build identifier: a UTC timestamp, stamped before each commit.
 *
 * Deliberately not a sha: a commit cannot contain its own. What matters is that it is
 * unique and greppable.
 *
 * It exists to answer "is this fix live?" without ambiguity: many fixes change no visible
 * text, so inspecting the deployed bundle cannot tell them apart. This marker always can —
 * and it is readable from the browser console, which separates a stale browser cache from
 * a deployment that has not landed yet.
 */
export const BUILD_ID = '20261024-1521';
